import { Injectable } from '@angular/core';

import { Http } from '@angular/http';

import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';

import { Api } from './api';
import { Clients } from './clients';
import { Assessments } from './assessments';

import { Client } from '../models/client';
import { UserData } from '../models/user';


@Injectable()
export class Items {
  items: Client[];
  userData: UserData;
  schedules:any;
  constructor(public http: Http, public api: Api, public clients: Clients, public assessments: Assessments) {
    
  }

  emailAssessments(item){
    return this.api.scheduleAssessments('schedules', item);
  }

  getAssessmentsURL(item){
    return this.api.getAssessmentsURL('schedules/url', item);
  }

  getNews(params?: any) {
    return this.api.getNews('notifications', params);

  }
  getVersion() {
    return this.api.getVersion('users/version');
  }

  getAccountDetails(){
    return this.api.getAccountDetails('account');
  }

  getClients(params?: any) {
    return this.clients.getClients(params);
  }

  clientChangeStatus(id, status) {
    return this.clients.clientChangeStatus(id, status);
  }

  setClientGrouping(ids, group_id, add) {
    ids = JSON.stringify(ids)
    return this.clients.setClientGrouping(ids, group_id, add);
  }

  getClientList(params?: any) {
    return this.clients.getClientList(params);
  }

  getClientListPaged(params?: any) {
    return this.api.getClientsPaged('clients/withgroup' + params);
  }

  getClientSmallList(params?: any) {
    return this.clients.getClientSmallList(params);
  }

  getSchedules(params?: any) {
    return this.clients.getSchedules(params);
  }

  getPractices() {
    return this.api.getPractices('practice');
  }

  createEmailTemplate(item) {
    return this.api.createEmailTemplate('practice/templates', item);
  }

  getEmailTemplates() {
    return this.api.getEmailTemplates('practice/templates');
  }

  getClientNotesAndResponses(clientId: any) {
    return this.api.getClientNotesAndResponses('clients', clientId);
  }

  getAssessments(params?: any) {
    return this.assessments.getAssessments(params);
  }

  getAssessmentList(params?: any) {
    return this.assessments.getAssessmentList();
  }

  getBatteries(params?: any) {
    return this.assessments.getBatteries();
  }

  getBatteryList(params?: any) {
    return this.assessments.getBatteryList();
  }

  getAssessmentQuestions(assessmentId : string, uniqueId : string) {
    return this.api.getAssessmentQuestions('assessments', assessmentId, uniqueId);
  }

  getAssessmentForSchedule(scheduleId : string) {
    let seq = this.api.getAssessmentForSchedule('schedules', scheduleId).share();
    seq
    .map(res => res)
    .subscribe(res => {
      // If the API returned a successful response, push the response in the clientsList
      this.schedules=res;
    }, err => {
      console.error('ERROR', err);
    });
    return seq
     
  }

  unsubscribe(scheduleId : string) {
    return this.api.unsubscribe('schedules', scheduleId);
  }

  joinPractice(inviteId) {
    return this.api.joinPractice('practice/accept', inviteId);
  }

  submitAssessment(answers:any, clientId : string, body: any) {
    return this.api.submitAssessment('clients', clientId, body, answers).share();
  }

  submitScheduledAssessment(answers:any, body: any) {
    return this.api.submitScheduledAssessment('scheduled_responses', body, answers).share();
  }

  editScheduleAssessments(item, id) {
    return this.api.editScheduleAssessments('schedules', item,id);
  }

  downloadAssessment(item) {
    return this.api.downloadAssessment('assessments', item.id);
  }

  deleteScheduleAssessments(id) {
    return this.api.deleteSchedule('schedules',id);
  }

  deleteReport(id) {
    return this.api.deleteReport('responses',id);
  }

  changeDate(id,body) {
    return this.api.changeDate('responses',id, body);
  }

  assignClient(id,body) {
    return this.api.assignClient('responses',id, body);
  }

  query(params?: any) {
    return this.api.getNews('news', params);

  }

  addClient(client: Client) {
    return this.clients.addClient(client);
  }

  addClientStatic(client: Client) {
    return this.clients.addClientStatic(client);
  }

  getUsers() {
    return this.api.getUsers('practices/get_users');
  }

  assignGrouping(item) {
    return this.api.assignGrouping('users/assign',item);
  }

  addUser(user: any) {
    return this.api.addUser('practice/invite',user);
  }

  deleteUser(id: any) {
    return this.api.deleteUser('practice/user',id);
  }

  editClient(client: Client, id:string) {
    return this.clients.editClient(client,id);
  }

  editBattery(battery, id) {
    return this.assessments.editBattery(battery,id);
  }

  deleteClient(client: Client, id:string) {
    return this.clients.deleteClient(client,id);
  }

  deleteClientStatic(client: Client, id:string) {
    return this.clients.deleteClientStatic(client,id);
  }

  deleteBattery(battery:any, id:string) {
    return this.assessments.deleteBattery(battery,id);
  }

  addNote(item) {
    return this.clients.addNote(item);
  }

  addBattery(item) {
    return this.assessments.addBattery(item);
  }

  editNote(item) {
    return this.clients.editNote(item);
  }

  deleteNote(id: any) {
    return this.clients.deleteNote(id);
  }

  updateUser(item, id) {
    this.userData = <UserData>JSON.parse(localStorage.getItem('userData'));
    this.userData.first_name = item.first_name;
    this.userData.last_name = item.last_name;
    this.userData.email = item.email;
    this.userData.title_id = item.title_id;
    this.userData.profession_id = item.profession_id;
    return this.api.updateUser('users',this.userData, id);
  }

  updateUserRole(item, id){    
    return this.api.updateUser('users/edit',item, id);
  }

  updatPracticeName(item, id){
    return this.api.updatePracticeName('practices',item, id);
  }

  getReport(link){
    return this.api.getReportPDF(link);
  }

  getResultPDF(id){
    return this.api.getResultPDF('reports', id);
  }

  getReportURL(id){
    return this.api.getReportURL('reports',id);
  }

  getClientReportURL(id){
    return this.api.getClientReportURL('client_reports',id);
  }

  getAssessmentURL(id){
    return this.api.getAssessmentURL('assessments',id);
  }

  planSignup(body: string, userId: string) {
    return this.api.planSignup('users', body, userId)  
  }

  getGroupings(params?: any) {
    return this.clients.getGroupings(params);
  }

  addGrouping(item) {
    return this.api.addGrouping('groupings', item);
  }

  editGrouping(item, id) {
    return this.api.editGrouping('groupings', item, id);
  }

  deleteGrouping(id: any) {
    return this.api.deleteGrouping('groupings', id);
  }

  getClientGrouping(id) {
    return this.api.getClientGrouping('groupings/client_get', id);
  }

  addClientGrouping(item, id) {
    return this.api.addClientGrouping('groupings/client_add', item, id);
  }

  deleteClientGrouping(item, id) {
    return this.api.deleteClientGrouping('groupings/client_delete', item, id);
  }

  addToken() {
    return this.api.addToken('tokens/add');
  }

}



// WEBPACK FOOTER //
// ./src/providers/items.ts